function capitalizeNameToken(token) {
  if (!token) return '';
  const lower = token.toLowerCase().replace(/\u2019/g, "'");
  return lower.replace(/(^|['-])([a-z])/g, (match, sep, letter, offset, str) => {
    const afterApostrophe = sep === "'";
    if (afterApostrophe && letter === 's' && offset + 2 === str.length) {
      return sep + letter;
    }
    return sep + letter.toUpperCase();
  });
}

/**
 * Title-case a person name: capitalize the first letter and any letter after
 * an apostrophe or hyphen (e.g. "o'brien" → "O'Brien", "mary-jane" → "Mary-Jane").
 * @param {string | null | undefined} value
 * @returns {string}
 */
export function toPersonNameCase(value) {
  if (value == null || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  return trimmed
    .split(/\s+/)
    .map((word) => capitalizeNameToken(word))
    .join(' ');
}

/** @param {string} fieldName */
export function isPersonNameField(fieldName) {
  return (
    fieldName === 'firstName' ||
    fieldName === 'lastName' ||
    fieldName === 'FirstName' ||
    fieldName === 'LastName'
  );
}

/**
 * Normalize a first/last name field on blur or before submit.
 * @param {string} fieldName
 * @param {string} value
 * @returns {string}
 */
export function normalizePersonNameFieldValue(fieldName, value) {
  if (!isPersonNameField(fieldName)) return value;
  if (value == null || typeof value !== 'string') return value;
  return toPersonNameCase(value);
}
